import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, LockIcon } from 'lucide-react';
interface PasswordProtectionProps {
  children: React.ReactNode;
}
const PasswordProtection: React.FC<PasswordProtectionProps> = ({
  children
}) => {
  // Initialize with undefined to indicate "not checked yet" state
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // Check authentication status immediately on component mount
  useEffect(() => {
    // Synchronously check if user is already authenticated
    const authStatus = localStorage.getItem('isAuthenticated');
    setIsAuthenticated(authStatus === 'true');
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === '1234') {
      setIsAuthenticated(true);
      localStorage.setItem('isAuthenticated', 'true');
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
    }
  };
  // Show nothing during initial authentication check
  // This prevents the flash of the login screen
  if (isAuthenticated === null) {
    return null;
  }
  if (isAuthenticated) {
    return <>{children}</>;
  }
  return <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4" data-id="element-140">
      <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md" data-id="element-141">
        <div className="flex flex-col items-center" data-id="element-142">
          <div className="bg-blue-100 p-3 rounded-full" data-id="element-143">
            <ShoppingBagIcon className="h-10 w-10 text-blue-600" data-id="element-144" />
          </div>
          <h2 className="mt-6 text-2xl font-bold text-gray-900" data-id="element-145">
            Multichannel Listings
          </h2>
          <div className="flex items-center mt-2 text-gray-600" data-id="element-146">
            <LockIcon className="h-4 w-4 mr-2" data-id="element-147" />
            <p data-id="element-148">Protected Area</p>
          </div>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-149">
          <div data-id="element-150">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-151">
              Password
            </label>
            <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Enter password" data-id="element-152" />
            {error && <p className="mt-2 text-sm text-red-600" data-id="element-153">{error}</p>}
          </div>
          <div data-id="element-154">
            <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-155">
              Enter
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default PasswordProtection;